import { ids } from "@icarros/theme-react";
import styled, { css } from "styled-components";
import { ActionIconSizes } from "./constants";
const { color, size } = ids || {};
const getSize = (internalSize) => {
    switch (internalSize) {
        case "small":
            return css `
        height: ${size.general.ids_size_general_24x};
        width: ${size.general.ids_size_general_24x};
      `;
        case "medium":
            return css `
        height: ${size.general.ids_size_general_32x};
        width: ${size.general.ids_size_general_32x};
      `;
        case "large":
            return css `
        height: ${size.general.ids_size_general_40x};
        width: ${size.general.ids_size_general_40x};
      `;
    }
};
export const StyledActionIcon = styled.button `
  ${({ size }) => getSize(size || ActionIconSizes.medium)}
  background: ${color.backgrounds.ids_color_bg_base};
  border-radius: ${size.corner_radius.ids_size_cornerRadius_layout_02};
  border: ${size.border_width.ids_size_border_small} solid
    ${color.border.ids_color_border_soft};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
//# sourceMappingURL=ActionIcon.style.js.map